<template>
  <detail-layout :Config="pageConfig">
    <el-table v-loading="IsLoading" element-loading-text="加载中" :data="[service]">
      <el-table-column label="物料名称">
        <template scope="props">
          {{props.row.ProductName}}
        </template>
      </el-table-column>
      <el-table-column label="物料编码">
        <template scope="props">
          {{props.row.ProductCode}}
        </template>
      </el-table-column>
      <el-table-column label="品项">
        <template scope="props">
          <el-tag type="primary">{{props.row.ConditionName}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="品牌">
        <template scope="props">
          {{props.row.ProductBrandName}}
        </template>
      </el-table-column>
      <el-table-column label="机型">
        <template scope="props">
          {{props.row.ProductModelName}}
        </template>
      </el-table-column>
      <el-table-column label="模块">
        <template scope="props">
          {{props.row.ProductModuleName}}
        </template>
      </el-table-column>
      <el-table-column label="库存总数">
        <template scope="props">
          {{props.row.Quantity}}
        </template>
      </el-table-column>
    </el-table>
    <h3 style="font-size: 18px;padding: 10px 0;">批次清单</h3>
    <el-table v-loading="IsLoading" element-loading-text="加载中" :data="servicelist">
      <el-table-column label="批次号" width="170">
        <template scope="props">
          {{props.row.Code}}
        </template>
      </el-table-column>
      <el-table-column label="库存数" width="170">
        <template scope="props">
          {{props.row.Quantity}}
        </template>
      </el-table-column>
      <el-table-column label="区域">
        <template scope="props">
          {{props.row.regionName}}
        </template>
      </el-table-column>
      <el-table-column label="库位">
        <template scope="props">
          {{props.row.CurrentLocationCode}}
        </template>
      </el-table-column>
      <el-table-column label="仓库">
        <template scope="props">
          {{props.row.CurrentWarehouseName}}
        </template>
      </el-table-column>
      <el-table-column label="入库天数">
        <template scope="props">
          {{props.row.Age}}
        </template>
      </el-table-column>
      <el-table-column
        label="入库时间">
        <template scope="props">
          {{props.row.InStockDate | date('YYYY-MM-DD')}}
        </template>
      </el-table-column>
    </el-table>
  </detail-layout>
</template>

<script>
import DetailLayout from '@/components/pages/Inventory/DetailLayout'
import o from '@/odata'
export default {
  mounted() {
    this.initServices()
  },
  data() {
    return {
      pageConfig: {
        StepsBarEnabled: true,
        Breadcrumbs: [
          {
            to: {name: 'ManagedList'},
            name: '代管库查询',
          },
          {
            name: '自有代管库-物料详情',
          },
        ],
      },
      service: {},
      servicelist: [],
      IsLoading: false,
    }
  },
  methods: {
    initServices: function() {
      this.IsLoading = true
      const Services = o(`CustomerManagedProductQuantity/Services.GetDetail(ConditionId = ${this.$route.params.ConditionId},ProductId = ${this.$route.params.ProductId},lotType='private')`)
      Services.get().then((response) => {
        this.IsLoading = false
        this.service = response.data[0]
        this.servicelist = this.service.Lots
      }).catch((response) => {
        this.IsLoading = false
        this.$alert('加载失败')
      })
    },
  },
  components: {
    DetailLayout,
  },
}
</script>

<style lang="less" scoped>
.red{
  color: #FF4949;
}
.demo-table-expand{
  .el-form-item{
    width: 24%;
     margin-bottom: 0;
    margin-right: 0;
    span{
      font-size: 14px;
      color: #1F2D3D;
    }
    .span-blue{
      color: #20A0FF;
    }
  }
}

h3{
  color: 354052;
  font-size: 24px;
  span{
    font-size: 20px;
    color: #A6AFB7;
    font-weight: normal;
  }
}
.pop-box .el-dialog--large{
  width: 80%;
}
.el-table__expanded-cell{
  background: #F5F7FA;
  box-shadow: inset 0 0 0 0 #E0E6ED, inset 0 0 0 1px #E0E6ED;
}
.el-dialog__body .el-form{
  padding-bottom: 20px;
}
.pop-box p.pull-left{
  font-size: 14px;
  color: #7F8FA4;
}

.list-box{
  h4{
    margin-bottom: 25px;
    .el-button{
      margin-top: -5px;
      margin-right: 15px;
    }
  }
}
.chose-box{
  margin-bottom: 20px;
  .chose-item{
    margin-right: 20px;
    display: inline-block;
    p{
      margin-bottom: 5px;
      font-size: 14px;
      color: #7F8FA4;
    }
  }
}
.replacement{
  background: #FEFEFE;
  border: 1px solid #BCCCDA;
  border-radius: 4px;
  padding: 15px 20px;
  margin-bottom: 10px;
  font-size: 14px;
  color: #7F8FA4;
}
.replacement span{
  color: #354052;
  margin-left: 20px;
}
.review-table{
  padding-bottom: 30px;
  border-bottom: 1px solid #E0E6ED;
  h5{
    font-size: 18px;
    color: #7F8FA4;
    margin: 0 0 10px;
  }
  
  td{
    padding: 15px;
  }
  table thead td{
    background: #E5E9F2;
    box-shadow: inset 0 1px 0 0 #E0E6ED, inset 1px 0 0 0 #E0E6ED, inset 0 -1px 0 0 #E0E6ED;
  }
  tbody{
    background: #FFFFFF;
    box-shadow: inset 0 0 0 0 #E0E6ED, inset 0 0 0 1px #E0E6ED;
  }
}
.pop-box.review-table{
  table{
    margin-bottom: 30px;
  }
  table tbody td{
    border-bottom:1px solid #E0E6ED;
  }
}
table{
  width: 100%;
  border-collapse: collapse;
}
.steps{
  display: none;
}
</style>



// WEBPACK FOOTER //
// ManagedSelfDetail.vue?a46dabe2